// // ElectionCallerbook.jsx
// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import styles from "./Styles/ElectionCallerbook.module.css";

// const ElectionCallerbook = () => {
//   // State Management
//   const [campaigns, setCampaigns] = useState([]);
//   const [selectedCampaign, setSelectedCampaign] = useState(null);
//   const [agents, setAgents] = useState([]);
//   const [selectedAgent, setSelectedAgent] = useState(null);
//   const [selectedVoters, setSelectedVoters] = useState(new Set());
//   const [voters, setVoters] = useState([]); // Filtered and searched voters

//   // UI State
//   const [loading, setLoading] = useState(false);
//   const [isCalling, setIsCalling] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   // Search & Filter
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [currentPage, setCurrentPage] = useState(1);
//   const votersPerPage = 15;

//   // Notification State
//   const [notification, setNotification] = useState({
//     show: false,
//     type: "",
//     message: "",
//   });

//   // Detect mobile
//   useEffect(() => {
//     const mediaQuery = window.matchMedia("(max-width: 768px)");
//     setIsMobile(mediaQuery.matches);

//     const handler = (e) => setIsMobile(e.matches);
//     mediaQuery.addEventListener("change", handler);
//     return () => mediaQuery.removeEventListener("change", handler);
//   }, []);

//   // Effects
//   useEffect(() => {
//     console.log("Component mounted, fetching campaigns and agents");
//     fetchCampaigns();
//     fetchAgents();
//   }, []);

//   // Reset voters and selection when campaign changes
//   useEffect(() => {
//     if (selectedCampaign) {
//       console.log("Campaign selected:", selectedCampaign._id);
//       setVoters(selectedCampaign.volterList || []);
//       setSelectedVoters(new Set());
//       setCurrentPage(1);
//       setSearchTerm("");
//       setStatusFilter("all");
//     } else {
//       setVoters([]);
//       setSelectedVoters(new Set());
//     }
//   }, [selectedCampaign]);

//   // Notification handler
//   const showNotification = useCallback((type, message) => {
//     console.log(`Showing notification: ${type} - ${message}`);
//     setNotification({ show: true, type, message });
//     setTimeout(
//       () => setNotification({ show: false, type: "", message: "" }),
//       4000
//     );
//   }, []);

//   // SSE Parser Function (adapted from CampaignManager)
//   const parseSSE = useCallback(async (response) => {
//     console.log("Parsing SSE response...");
//     if (!response.ok) {
//       const error = new Error(
//         `HTTP error! status: ${response.status} ${response.statusText}`
//       );
//       console.error("SSE HTTP Error:", error);
//       throw error;
//     }

//     if (!response.body) {
//       const error = new Error("ReadableStream not supported");
//       console.error("SSE ReadableStream Error:", error);
//       throw error;
//     }

//     const reader = response.body.getReader();
//     const decoder = new TextDecoder();
//     let fullResponse = "";

//     try {
//       console.log("Reading SSE stream...");
//       while (true) {
//         const { done, value } = await reader.read();
//         if (done) break;
//         fullResponse += decoder.decode(value, { stream: true });
//       }
//     } catch (readError) {
//       console.error("Error reading SSE stream:", readError);
//       throw readError;
//     } finally {
//       reader.releaseLock();
//     }

//     console.log("Full SSE Response:", fullResponse);

//     // Parse SSE events
//     const events = fullResponse.split("\n\n").filter((event) => event.trim());
//     console.log("Parsed SSE events count:", events.length);
//     let lastData = null;
//     let hasError = false;
//     let errorMessage = "";

//     for (const eventStr of events) {
//       const lines = eventStr.split("\n");
//       let eventType = "message"; // default
//       let data = "";

//       for (const line of lines) {
//         if (line.startsWith("event: ")) {
//           eventType = line.slice(7).trim();
//         } else if (line.startsWith("data: ")) {
//           data += line.slice(6) + "\n";
//         }
//       }

//       if (data.trim()) {
//         try {
//           const parsedData = JSON.parse(data.trim());
//           console.log(`Event ${eventType}:`, parsedData);
//           lastData = parsedData;
//           if (parsedData.error) {
//             hasError = true;
//             errorMessage = parsedData.error;
//             console.error("SSE Event Error:", parsedData.error);
//           }
//           if (parsedData.success !== undefined) {
//             if (parsedData.success) {
//               console.log("SSE Success Event:", parsedData);
//               return parsedData; // Return on success
//             } else {
//               hasError = true;
//               errorMessage = parsedData.message || "Call initiation failed";
//               console.error("SSE Failure Event:", parsedData);
//             }
//           }
//         } catch (parseError) {
//           console.error("Error parsing SSE data:", parseError, data);
//         }
//       }
//     }

//     // If error found in stream
//     if (hasError) {
//       const error = new Error(errorMessage);
//       console.error("SSE Stream Error:", error);
//       throw error;
//     }

//     // If no specific success/error found, return the last data or throw
//     if (lastData && lastData.success) {
//       console.log("SSE Last Data Success:", lastData);
//       return lastData;
//     } else {
//       const error = new Error(
//         "No valid data received from SSE stream or operation failed"
//       );
//       console.error("SSE No Valid Data:", error);
//       throw error;
//     }
//   }, []);

//   // API Functions
//   const fetchCampaigns = useCallback(async () => {
//     console.log("Fetching campaigns...");
//     try {
//       const creatorId = localStorage.getItem("userId");
//       console.log("Creator ID:", creatorId);
//       if (!creatorId) {
//         const error = new Error("No creator ID found in localStorage");
//         console.error("Fetch Campaigns Error:", error);
//         showNotification("error", error.message);
//         return;
//       }
//       setLoading(true);
//       const token = localStorage.getItem("token");
//       console.log("Token for fetch:", !!token);
//       const response = await fetch(
//         `https://prod.toxboxai.com/api/election-campaign/by-creator/${creatorId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       console.log("Fetch response status:", response.status);

//       if (!response.ok) {
//         const error = new Error(`HTTP error! status: ${response.status}`);
//         console.error("Fetch HTTP Error:", error);
//         showNotification("error", error.message);
//         return;
//       }

//       const result = await response.json();
//       console.log("Fetch result:", result);
//       if (result.success) {
//         console.log("Campaigns fetched successfully:", result.data);
//         setCampaigns(result.data);
//       } else {
//         console.log("Fetch failed:", result.error);
//         showNotification("error", result.error || "Failed to fetch campaigns");
//       }
//     } catch (error) {
//       console.error("Error fetching campaigns:", error);
//       showNotification("error", error.message || "Network error occurred");
//     } finally {
//       setLoading(false);
//       console.log("Fetch campaigns complete");
//     }
//   }, [showNotification]);

//   const fetchAgents = useCallback(async () => {
//     console.log("Fetching agents...");
//     try {
//       const creatorId = localStorage.getItem("userId");
//       console.log("Creator ID for agents:", creatorId);
//       if (!creatorId) {
//         const error = new Error("No creator ID found in localStorage");
//         console.error("Fetch Agents Error:", error);
//         showNotification("error", error.message);
//         return;
//       }
//       setLoading(true);
//       const response = await fetch(
//         `https://prod.toxboxai.com/api/election-agent/by-creator/${creatorId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       console.log("Agents fetch response status:", response.status);

//       if (!response.ok) {
//         const error = new Error(`HTTP error! status: ${response.status}`);
//         console.error("Fetch Agents HTTP Error:", error);
//         showNotification("error", error.message);
//         return;
//       }

//       const result = await response.json();
//       console.log("Agents fetch result:", result);
//       if (result.agents) {
//         console.log("Agents fetched successfully:", result.agents);
//         setAgents(result.agents);
//       } else {
//         console.log("Fetch agents failed:", result);
//         showNotification("error", "Failed to fetch agents");
//       }
//     } catch (error) {
//       console.error("Error fetching agents:", error);
//       showNotification("error", error.message || "Network error occurred");
//     } finally {
//       setLoading(false);
//       console.log("Fetch agents complete");
//     }
//   }, [showNotification]);

//   // Filter and Search Voters
//   const getFilteredVoters = useCallback(() => {
//     console.log("Getting filtered voters...");
//     let filtered = [...voters];

//     // Apply search filter
//     if (searchTerm) {
//       console.log("Applying search filter:", searchTerm);
//       const search = searchTerm.toLowerCase();
//       filtered = filtered.filter(
//         (voter) =>
//           voter.voterName?.toLowerCase().includes(search) ||
//           voter.voterId?.toLowerCase().includes(search) ||
//           voter.voterContact?.toLowerCase().includes(search) ||
//           voter.voterAddress?.toLowerCase().includes(search)
//       );
//     }

//     // Apply status filter
//     if (statusFilter !== "all") {
//       console.log("Applying status filter:", statusFilter);
//       filtered = filtered.filter((voter) => voter.callStatus === statusFilter);
//     }

//     console.log(`Filtered voters count: ${filtered.length}`);
//     return filtered;
//   }, [voters, searchTerm, statusFilter]);

//   const filteredVoters = getFilteredVoters();
//   const paginatedVoters = useMemo(() => {
//     const startIndex = (currentPage - 1) * votersPerPage;
//     return filteredVoters.slice(startIndex, startIndex + votersPerPage);
//   }, [filteredVoters, currentPage, votersPerPage]);
//   const totalPages = Math.ceil(filteredVoters.length / votersPerPage);
//   const isAllSelected =
//     filteredVoters.length > 0 &&
//     filteredVoters.every((voter) => selectedVoters.has(voter._id));
//   const selectionCount = selectedVoters.size;

//   // Selection Management
//   const toggleVoterSelection = useCallback((voterId) => {
//     console.log("Toggling selection for voter:", voterId);
//     setSelectedVoters((prev) => {
//       const newSelection = new Set(prev);
//       if (newSelection.has(voterId)) {
//         newSelection.delete(voterId);
//         console.log("Deselected voter:", voterId);
//       } else {
//         newSelection.add(voterId);
//         console.log("Selected voter:", voterId);
//       }
//       console.log("New selection size:", newSelection.size);
//       return newSelection;
//     });
//   }, []);

//   const toggleSelectAll = useCallback(() => {
//     const allSelected = filteredVoters.every((voter) =>
//       selectedVoters.has(voter._id)
//     );
//     console.log(
//       "Toggle select all: allSelected?",
//       allSelected,
//       "filtered count:",
//       filteredVoters.length
//     );

//     if (allSelected) {
//       setSelectedVoters(new Set());
//       console.log("Deselected all");
//     } else {
//       setSelectedVoters(new Set(filteredVoters.map((v) => v._id)));
//       console.log("Selected all");
//     }
//   }, [filteredVoters, selectedVoters]);

//   // Call Management (adapted from CampaignManager)
//   const initiateCall = useCallback(
//     async (votersToCall, isBulk = false) => {
//       console.log(
//         `${isBulk ? "Bulk" : "Single"} call initiated for ${
//           votersToCall.length
//         } voters`
//       );

//       if (votersToCall.length === 0) {
//         showNotification("warning", "No voters selected for calling");
//         return;
//       }

//       if (!selectedAgent) {
//         showNotification("error", "Please select an agent first");
//         return;
//       }

//       // Validate and build calls array
//       const validVoters = votersToCall.filter((voter) => {
//         let contact = voter.voterContact;
//         if (contact && !contact.startsWith("+")) {
//           contact = "+" + contact.replace(/[\s-]/g, "");
//         }
//         if (!contact || !contact.trim()) {
//           console.warn(`Voter ${voter.voterName} skipped: No contact number`);
//           return false;
//         }
//         // Basic phone validation (starts with + and digits)
//         if (!/^\+\d{10,15}$/.test(contact)) {
//           console.warn(
//             `Voter ${voter.voterName} skipped: Invalid contact format after normalization: ${contact}`
//           );
//           return false;
//         }
//         if (!voter._id) {
//           console.warn(`Voter ${voter.voterName} skipped: Missing ID`);
//           return false;
//         }
//         return true;
//       });

//       console.log("Valid Voters:", validVoters);

//       if (validVoters.length === 0) {
//         showNotification(
//           "warning",
//           "No valid voters with contact numbers selected"
//         );
//         return;
//       }

//       const calls = validVoters.map((voter) => {
//         let contact = voter.voterContact;
//           if (contact && !contact.startsWith('+')) {
//             contact = '+' + contact.replace(/[\s-]/g, '');
//           }
//         return {
//           toNumber: contact,
//           //   fromNumber: selectedAgent.phoneNumber || "+918035738038", // Use agent's phone or default
//           fromNumber: "+918035738038", // Use agent's phone or default

//           customerName: voter.voterName || "Unknown",
//           type: voter.type || "custom",
//           voterId: voter._id,
//           promptId:
//             voter.linkedPromptTemplate?.promptID ||
//             selectedAgent.templateId ||
//             "", // Fallback to agent's templateId
//         };
//       });

//       console.log("Calls array:", calls);

//       const payload = {
//         assignedAgentId: selectedAgent.agentId,
//         // assignedAgentId: agentId,
//         calls: calls,
//       };

//       console.log("Sending payload:", payload);

//       try {
//         setIsCalling(true);
//         const token = localStorage.getItem("token");
//         if (!token) {
//           const error = new Error("No authentication token found");
//           console.error("Call Token Error:", error);
//           showNotification("error", error.message);
//           return;
//         }
//         console.log("Token exists for call:", !!token);

//         console.log("Making fetch request...");
//         const response = await fetch(
//           "https://prod.toxboxai.com/api/election-call/initiate-call",
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(payload),
//           }
//         );

//         console.log("Call response status:", response.status);

//         const result = await parseSSE(response);
//         console.log("Parsed SSE Result:", result);

//         if (result.success) {
//           console.log("Call success");
//           const callType = isBulk ? "bulk" : "single";
//           showNotification(
//             "success",
//             `Initiated ${callType} call${isBulk ? "s" : ""} for ${
//               calls.length
//             } voter${calls.length > 1 ? "s" : ""} successfully`
//           );
//           if (isBulk && selectionCount > 0) {
//             setSelectedVoters(new Set()); // Clear selection after bulk
//           }
//           // Optionally refresh campaigns
//           fetchCampaigns();
//         } else {
//           const errorMsg =
//             result.error || result.message || "Failed to initiate call";
//           console.error("Call API Error:", errorMsg);
//           showNotification("error", errorMsg);
//         }
//       } catch (error) {
//         console.error("Error initiating call:", error);
//         const errorMsg =
//           error.message || "Network error or invalid response occurred";
//         showNotification("error", errorMsg);
//       } finally {
//         setIsCalling(false);
//         console.log("Call complete");
//       }
//     },
//     [selectedAgent, showNotification, parseSSE, fetchCampaigns, selectionCount]
//   );

//   const handleSingleCall = useCallback(() => {
//     if (selectionCount !== 1) return;
//     const selectedVoter = Array.from(selectedVoters)
//       .map((id) => filteredVoters.find((v) => v._id === id))
//       .filter(Boolean)[0];
//     if (selectedVoter) {
//       initiateCall([selectedVoter], false);
//     }
//   }, [selectionCount, selectedVoters, filteredVoters, initiateCall]);

//   const handleBulkCall = useCallback(() => {
//     if (selectionCount === 0) return;
//     const selected = filteredVoters.filter((voter) =>
//       selectedVoters.has(voter._id)
//     );
//     initiateCall(selected, true);
//   }, [selectionCount, selectedVoters, filteredVoters, initiateCall]);

//   // Utility Functions
//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });

//   const getStatusBadge = (status) => {
//     const badges = {
//       not_called: { label: "Not Called", class: styles.statusNotCalled },
//       completed: { label: "Completed", class: styles.statusCompleted },
//       missed: { label: "Missed", class: styles.statusMissed },
//     };

//     const badge = badges[status] || badges.not_called;
//     return (
//       <span className={`${styles.statusBadge} ${badge.class}`}>
//         {badge.label}
//       </span>
//     );
//   };

//   const canCall = !!selectedAgent && selectionCount > 0;

//   const renderVoterContent = () => {
//     if (loading) {
//       return (
//         <div className={styles.loadingState}>
//           <div className={styles.spinner}></div>
//           <p>Loading...</p>
//         </div>
//       );
//     }

//     if (!selectedCampaign) {
//       return (
//         <div className={styles.emptyState}>
//           <div className={styles.emptyStateIcon}>🗳️</div>
//           <h2>Select a Campaign</h2>
//           <p>Choose a campaign to view voters and initiate calls</p>
//         </div>
//       );
//     }

//     if (filteredVoters.length === 0) {
//       return (
//         <div className={styles.emptyState}>
//           <div className={styles.emptyStateIcon}>🔍</div>
//           <h3>No voters found</h3>
//           <p>Try adjusting your search or filter criteria</p>
//         </div>
//       );
//     }

//     if (isMobile) {
//       // Card format for mobile
//       return (
//         <div className={styles.voterCards}>
//           {paginatedVoters.map((voter) => (
//             <div key={voter._id} className={styles.voterCard}>
//               <div className={styles.cardHeader}>
//                 <input
//                   type="checkbox"
//                   checked={selectedVoters.has(voter._id)}
//                   onChange={() => toggleVoterSelection(voter._id)}
//                   className={styles.checkbox}
//                   disabled={isCalling || loading}
//                 />
//                 <div className={styles.voterInfo}>
//                   <h4 className={styles.voterName}>
//                     {voter.voterName || "N/A"}
//                   </h4>
//                   <p className={styles.voterId}>ID: {voter.voterId || "N/A"}</p>
//                 </div>
//               </div>
//               <div className={styles.cardBody}>
//                 <p>
//                   <strong>Contact:</strong> {voter.voterContact || "N/A"}
//                 </p>
//                 <p className={styles.voterAddress}>
//                   <strong>Address:</strong> {voter.voterAddress || "N/A"}
//                 </p>
//                 <div className={styles.statusContainer}>
//                   <strong>Status:</strong> {getStatusBadge(voter.callStatus)}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       );
//     } else {
//       // Table format for desktop
//       return (
//         <div className={styles.voterTable}>
//           <table>
//             <thead>
//               <tr>
//                 <th>
//                   <input
//                     type="checkbox"
//                     checked={isAllSelected}
//                     onChange={toggleSelectAll}
//                     disabled={isCalling || loading}
//                   />
//                 </th>
//                 <th>Voter ID</th>
//                 <th>Name</th>
//                 <th>Contact</th>
//                 <th>Address</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedVoters.map((voter) => (
//                 <tr key={voter._id}>
//                   <td>
//                     <input
//                       type="checkbox"
//                       checked={selectedVoters.has(voter._id)}
//                       onChange={() => toggleVoterSelection(voter._id)}
//                       disabled={isCalling || loading}
//                     />
//                   </td>
//                   <td>{voter.voterId || "N/A"}</td>
//                   <td>{voter.voterName || "N/A"}</td>
//                   <td>{voter.voterContact || "N/A"}</td>
//                   <td className={styles.addressCell}>
//                     {voter.voterAddress || "N/A"}
//                   </td>
//                   <td>{getStatusBadge(voter.callStatus)}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       );
//     }
//   };

//   return (
//     <div className={styles.callerbook}>
//       {/* Notification */}
//       {notification.show && (
//         <div
//           className={`${styles.notification} ${styles[notification.type]} ${
//             styles.show
//           }`}
//         >
//           <div className={styles.notificationContent}>
//             <span className={styles.notificationIcon}>
//               {notification.type === "success" && "✅"}
//               {notification.type === "error" && "❌"}
//               {notification.type === "warning" && "⚠️"}
//               {notification.type === "info" && "ℹ️"}
//             </span>
//             <span className={styles.notificationMessage}>
//               {notification.message}
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Header */}
//       <header className={styles.header}>
//         <div className={styles.headerContent}>
//           <div className={styles.headerLeft}>
//             <h1 className={styles.title}>Election Caller Book</h1>
//             <p className={styles.subtitle}>
//               Initiate calls to voters efficiently
//             </p>
//           </div>
//         </div>
//       </header>

//       {/* Controls */}
//       <div className={styles.controls}>
//         <div className={styles.dropdownGroup}>
//           <div className={styles.formGroup}>
//             <label className={styles.label}>Select Campaign</label>
//             <select
//               value={selectedCampaign?._id || ""}
//               onChange={(e) => {
//                 const campaign = campaigns.find(
//                   (c) => c._id === e.target.value
//                 );
//                 setSelectedCampaign(campaign);
//               }}
//               className={styles.select}
//               disabled={loading}
//             >
//               <option value="">Choose a campaign...</option>
//               {campaigns.map((campaign) => (
//                 <option key={campaign._id} value={campaign._id}>
//                   {campaign.leaderName} - {campaign.partyName}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className={styles.formGroup}>
//             <label className={styles.label}>Select Agent</label>
//             <select
//               value={selectedAgent?._id || ""}
//               onChange={(e) => {
//                 const agent = agents.find((a) => a._id === e.target.value);
//                 setSelectedAgent(agent);
//               }}
//               className={styles.select}
//               disabled={loading}
//             >
//               <option value="">Choose an agent...</option>
//               {agents.map((agent) => (
//                 <option key={agent._id} value={agent._id}>
//                   {agent.avatarName} ({agent.language}, {agent.gender})
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Search and Filter */}
//         {selectedCampaign && (
//           <div className={styles.searchFilter}>
//             <div className={styles.searchBox}>
//               <input
//                 type="text"
//                 placeholder="Search voters..."
//                 value={searchTerm}
//                 onChange={(e) => {
//                   setSearchTerm(e.target.value);
//                   setCurrentPage(1);
//                 }}
//                 className={styles.searchInput}
//                 disabled={loading}
//               />
//             </div>
//             <select
//               value={statusFilter}
//               onChange={(e) => {
//                 setStatusFilter(e.target.value);
//                 setCurrentPage(1);
//               }}
//               className={styles.filterSelect}
//               disabled={loading}
//             >
//               <option value="all">All Status</option>
//               <option value="not_called">Not Called</option>
//               <option value="completed">Completed</option>
//               <option value="missed">Missed</option>
//             </select>
//           </div>
//         )}

//         {/* Call Buttons */}
//         {selectedCampaign && (
//           <div className={styles.callButtons}>
//             {selectionCount === 1 && canCall && (
//               <button
//                 className={styles.singleCallButton}
//                 onClick={handleSingleCall}
//                 disabled={isCalling || loading}
//               >
//                 📞 Single Call
//                 {isCalling && <span className={styles.spinner}></span>}
//               </button>
//             )}
//             {selectionCount > 1 && canCall && (
//               <button
//                 className={styles.bulkCallButton}
//                 onClick={handleBulkCall}
//                 disabled={isCalling || loading}
//               >
//                 📞 Bulk Call ({selectionCount})
//                 {isCalling && <span className={styles.spinner}></span>}
//               </button>
//             )}
//             {selectionCount > 0 && !canCall && (
//               <span className={styles.disabledMessage}>
//                 Select an agent to enable calls
//               </span>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Voter Content */}
//       {renderVoterContent()}

//       {/* Pagination - Only show on desktop or if not mobile */}
//       {!isMobile && totalPages > 1 && filteredVoters.length > 0 && (
//         <div className={styles.pagination}>
//           <button
//             onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//             disabled={currentPage === 1 || isCalling || loading}
//             className={styles.paginationButton}
//           >
//             ← Previous
//           </button>

//           <div className={styles.pageNumbers}>
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               const page = Math.max(1, currentPage - 2) + i;
//               if (page > totalPages) return null;

//               return (
//                 <button
//                   key={page}
//                   onClick={() => setCurrentPage(page)}
//                   disabled={isCalling || loading}
//                   className={`${styles.pageNumber} ${
//                     currentPage === page ? styles.active : ""
//                   }`}
//                 >
//                   {page}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             onClick={() =>
//               setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//             }
//             disabled={currentPage === totalPages || isCalling || loading}
//             className={styles.paginationButton}
//           >
//             Next →
//           </button>
//         </div>
//       )}

//       {/* Table Footer or Card Footer */}
//       {filteredVoters.length > 0 && (
//         <div className={styles.tableFooter}>
//           Showing {(currentPage - 1) * votersPerPage + 1} to{" "}
//           {Math.min(currentPage * votersPerPage, filteredVoters.length)} of{" "}
//           {filteredVoters.length} voters
//           {selectionCount > 0 && ` | Selected: ${selectionCount}`}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ElectionCallerbook;



// ElectionCallerbook.jsx  select camapgion and seelct agent
// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import styles from "./Styles/ElectionCallerbook.module.css";

// const ElectionCallerbook = () => {
//   // State Management
//   const [campaigns, setCampaigns] = useState([]);
//   const [selectedCampaign, setSelectedCampaign] = useState(null);
//   const [agents, setAgents] = useState([]);
//   const [selectedAgent, setSelectedAgent] = useState(null);
//   const [selectedVoters, setSelectedVoters] = useState(new Set());
//   const [voters, setVoters] = useState([]); // Filtered and searched voters

//   // UI State
//   const [loading, setLoading] = useState(false);
//   const [isCalling, setIsCalling] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   // Search & Filter
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [currentPage, setCurrentPage] = useState(1);
//   const votersPerPage = 15;

//   // Notification State
//   const [notification, setNotification] = useState({
//     show: false,
//     type: "",
//     message: "",
//   });

//   // Detect mobile
//   useEffect(() => {
//     const mediaQuery = window.matchMedia("(max-width: 768px)");
//     setIsMobile(mediaQuery.matches);

//     const handler = (e) => setIsMobile(e.matches);
//     mediaQuery.addEventListener("change", handler);
//     return () => mediaQuery.removeEventListener("change", handler);
//   }, []);

//   // Effects
//   useEffect(() => {
//     console.log("Component mounted, fetching campaigns and agents");
//     fetchCampaigns();
//     fetchAgents();
//   }, []);

//   // Reset voters and selection when campaign changes
//   useEffect(() => {
//     if (selectedCampaign) {
//       console.log("Campaign selected:", selectedCampaign._id);
//       setVoters(selectedCampaign.volterList || []);
//       setSelectedVoters(new Set());
//       setCurrentPage(1);
//       setSearchTerm("");
//       setStatusFilter("all");
//     } else {
//       setVoters([]);
//       setSelectedVoters(new Set());
//     }
//   }, [selectedCampaign]);

//   // Notification handler
//   const showNotification = useCallback((type, message) => {
//     console.log(`Showing notification: ${type} - ${message}`);
//     setNotification({ show: true, type, message });
//     setTimeout(
//       () => setNotification({ show: false, type: "", message: "" }),
//       4000
//     );
//   }, []);

//   // SSE Parser Function (adapted from CampaignManager)
//   const parseSSE = useCallback(async (response) => {
//     console.log("Parsing SSE response...");
//     if (!response.ok) {
//       const error = new Error(
//         `HTTP error! status: ${response.status} ${response.statusText}`
//       );
//       console.error("SSE HTTP Error:", error);
//       throw error;
//     }

//     if (!response.body) {
//       const error = new Error("ReadableStream not supported");
//       console.error("SSE ReadableStream Error:", error);
//       throw error;
//     }

//     const reader = response.body.getReader();
//     const decoder = new TextDecoder();
//     let fullResponse = "";

//     try {
//       console.log("Reading SSE stream...");
//       while (true) {
//         const { done, value } = await reader.read();
//         if (done) break;
//         fullResponse += decoder.decode(value, { stream: true });
//       }
//     } catch (readError) {
//       console.error("Error reading SSE stream:", readError);
//       throw readError;
//     } finally {
//       reader.releaseLock();
//     }

//     console.log("Full SSE Response:", fullResponse);

//     // Parse SSE events
//     const events = fullResponse.split("\n\n").filter((event) => event.trim());
//     console.log("Parsed SSE events count:", events.length);
//     let lastData = null;
//     let hasError = false;
//     let errorMessage = "";

//     for (const eventStr of events) {
//       const lines = eventStr.split("\n");
//       let eventType = "message"; // default
//       let data = "";

//       for (const line of lines) {
//         if (line.startsWith("event: ")) {
//           eventType = line.slice(7).trim();
//         } else if (line.startsWith("data: ")) {
//           data += line.slice(6) + "\n";
//         }
//       }

//       if (data.trim()) {
//         try {
//           const parsedData = JSON.parse(data.trim());
//           console.log(`Event ${eventType}:`, parsedData);
//           lastData = parsedData;
//           if (parsedData.error) {
//             hasError = true;
//             errorMessage = parsedData.error;
//             console.error("SSE Event Error:", parsedData.error);
//           }
//           if (parsedData.success !== undefined) {
//             if (parsedData.success) {
//               console.log("SSE Success Event:", parsedData);
//               return parsedData; // Return on success
//             } else {
//               hasError = true;
//               errorMessage = parsedData.message || "Call initiation failed";
//               console.error("SSE Failure Event:", parsedData);
//             }
//           }
//         } catch (parseError) {
//           console.error("Error parsing SSE data:", parseError, data);
//         }
//       }
//     }

//     // If error found in stream
//     if (hasError) {
//       const error = new Error(errorMessage);
//       console.error("SSE Stream Error:", error);
//       throw error;
//     }

//     // If no specific success/error found, return the last data or throw
//     if (lastData && lastData.success) {
//       console.log("SSE Last Data Success:", lastData);
//       return lastData;
//     } else {
//       const error = new Error(
//         "No valid data received from SSE stream or operation failed"
//       );
//       console.error("SSE No Valid Data:", error);
//       throw error;
//     }
//   }, []);

//   // API Functions
//   const fetchCampaigns = useCallback(async () => {
//     console.log("Fetching campaigns...");
//     try {
//       const creatorId = localStorage.getItem("userId");
//       console.log("Creator ID:", creatorId);
//       if (!creatorId) {
//         const error = new Error("No creator ID found in localStorage");
//         console.error("Fetch Campaigns Error:", error);
//         showNotification("error", error.message);
//         return;
//       }
//       setLoading(true);
//       const token = localStorage.getItem("token");
//       console.log("Token for fetch:", !!token);
//       const response = await fetch(
//         `https://prod.toxboxai.com/api/election-campaign/by-creator/${creatorId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       console.log("Fetch response status:", response.status);

//       if (!response.ok) {
//         const error = new Error(`HTTP error! status: ${response.status}`);
//         console.error("Fetch HTTP Error:", error);
//         showNotification("error", error.message);
//         return;
//       }

//       const result = await response.json();
//       console.log("Fetch result:", result);
//       if (result.success) {
//         console.log("Campaigns fetched successfully:", result.data);
//         setCampaigns(result.data);
//       } else {
//         console.log("Fetch failed:", result.error);
//         showNotification("error", result.error || "Failed to fetch campaigns");
//       }
//     } catch (error) {
//       console.error("Error fetching campaigns:", error);
//       showNotification("error", error.message || "Network error occurred");
//     } finally {
//       setLoading(false);
//       console.log("Fetch campaigns complete");
//     }
//   }, [showNotification]);

//   const fetchAgents = useCallback(async () => {
//     console.log("Fetching agents...");
//     try {
//       const creatorId = localStorage.getItem("userId");
//       console.log("Creator ID for agents:", creatorId);
//       if (!creatorId) {
//         const error = new Error("No creator ID found in localStorage");
//         console.error("Fetch Agents Error:", error);
//         showNotification("error", error.message);
//         return;
//       }
//       setLoading(true);
//       const response = await fetch(
//         `https://prod.toxboxai.com/api/election-agent/by-creator/${creatorId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       console.log("Agents fetch response status:", response.status);

//       if (!response.ok) {
//         const error = new Error(`HTTP error! status: ${response.status}`);
//         console.error("Fetch Agents HTTP Error:", error);
//         showNotification("error", error.message);
//         return;
//       }

//       const result = await response.json();
//       console.log("Agents fetch result:", result);
//       if (result.agents) {
//         console.log("Agents fetched successfully:", result.agents);
//         setAgents(result.agents);
//       } else {
//         console.log("Fetch agents failed:", result);
//         showNotification("error", "Failed to fetch agents");
//       }
//     } catch (error) {
//       console.error("Error fetching agents:", error);
//       showNotification("error", error.message || "Network error occurred");
//     } finally {
//       setLoading(false);
//       console.log("Fetch agents complete");
//     }
//   }, [showNotification]);

//   // Filter and Search Voters
//   const getFilteredVoters = useCallback(() => {
//     console.log("Getting filtered voters...");
//     let filtered = [...voters];

//     // Apply search filter
//     if (searchTerm) {
//       console.log("Applying search filter:", searchTerm);
//       const search = searchTerm.toLowerCase();
//       filtered = filtered.filter(
//         (voter) =>
//           voter.voterName?.toLowerCase().includes(search) ||
//           voter.voterId?.toLowerCase().includes(search) ||
//           voter.voterContact?.toLowerCase().includes(search) ||
//           voter.voterAddress?.toLowerCase().includes(search)
//       );
//     }

//     // Apply status filter
//     if (statusFilter !== "all") {
//       console.log("Applying status filter:", statusFilter);
//       filtered = filtered.filter((voter) => voter.callStatus === statusFilter);
//     }

//     console.log(`Filtered voters count: ${filtered.length}`);
//     return filtered;
//   }, [voters, searchTerm, statusFilter]);

//   const filteredVoters = getFilteredVoters();
//   const paginatedVoters = useMemo(() => {
//     const startIndex = (currentPage - 1) * votersPerPage;
//     return filteredVoters.slice(startIndex, startIndex + votersPerPage);
//   }, [filteredVoters, currentPage, votersPerPage]);
//   const totalPages = Math.ceil(filteredVoters.length / votersPerPage);
//   const isAllSelected =
//     filteredVoters.length > 0 &&
//     filteredVoters.every((voter) => selectedVoters.has(voter._id));
//   const selectionCount = selectedVoters.size;

//   // Selection Management
//   const toggleVoterSelection = useCallback((voterId) => {
//     console.log("Toggling selection for voter:", voterId);
//     setSelectedVoters((prev) => {
//       const newSelection = new Set(prev);
//       if (newSelection.has(voterId)) {
//         newSelection.delete(voterId);
//         console.log("Deselected voter:", voterId);
//       } else {
//         newSelection.add(voterId);
//         console.log("Selected voter:", voterId);
//       }
//       console.log("New selection size:", newSelection.size);
//       return newSelection;
//     });
//   }, []);

//   const toggleSelectAll = useCallback(() => {
//     const allSelected = filteredVoters.every((voter) =>
//       selectedVoters.has(voter._id)
//     );
//     console.log(
//       "Toggle select all: allSelected?",
//       allSelected,
//       "filtered count:",
//       filteredVoters.length
//     );

//     if (allSelected) {
//       setSelectedVoters(new Set());
//       console.log("Deselected all");
//     } else {
//       setSelectedVoters(new Set(filteredVoters.map((v) => v._id)));
//       console.log("Selected all");
//     }
//   }, [filteredVoters, selectedVoters]);

//   // Call Management (adapted from CampaignManager)
//   const initiateCall = useCallback(
//     async (votersToCall, isBulk = false) => {
//       console.log(
//         `${isBulk ? "Bulk" : "Single"} call initiated for ${
//           votersToCall.length
//         } voters`
//       );

//       if (votersToCall.length === 0) {
//         showNotification("warning", "No voters selected for calling");
//         return;
//       }

//       if (!selectedAgent) {
//         showNotification("error", "Please select an agent first");
//         return;
//       }

//       // Validate and build calls array
//       const validVoters = votersToCall.filter((voter) => {
//         let contact = voter.voterContact;
//         if (contact && !contact.startsWith("+")) {
//           contact = "+" + contact.replace(/[\s-]/g, "");
//         }
//         if (!contact || !contact.trim()) {
//           console.warn(`Voter ${voter.voterName} skipped: No contact number`);
//           return false;
//         }
//         // Basic phone validation (starts with + and digits)
//         if (!/^\+\d{10,15}$/.test(contact)) {
//           console.warn(
//             `Voter ${voter.voterName} skipped: Invalid contact format after normalization: ${contact}`
//           );
//           return false;
//         }
//         if (!voter._id || !voter.type) {
//           console.warn(`Voter ${voter.voterName} skipped: Missing ID or type`);
//           return false;
//         }
//         return true;
//       });

//       console.log("Valid Voters:", validVoters);

//       if (validVoters.length === 0) {
//         showNotification(
//           "warning",
//           "No valid voters with contact numbers selected"
//         );
//         return;
//       }

//       const firstVoter = validVoters[0];
//     //   const agentId = firstVoter.linkedPromptTemplate?.agentId || selectedAgent._id;
//           const agentId = firstVoter.linkedPromptTemplate?.agentId;

//       if (!agentId) {
//         showNotification("error", "No agent ID found in voter templates");
//         return;
//       }

//       // Build calls array with dynamic campaign data per voter
//       const cleanPhoneNumber = (phone) => phone.replace(/[+\s-()]/g, "");
//       const calls = validVoters.map((voter) => {
//         let contact = voter.voterContact;
//         // if (contact && !contact.startsWith("+")) {
//         //   contact = "+" + contact.replace(/[\s-]/g, "");
//         // }
//         return {
//           toNumber: cleanPhoneNumber(contact),
//           fromNumber: "8035738038",
//           customerName: voter.voterName || "Unknown",
//           type: voter.type,
//           voterId: voter._id,
//           promptId: voter.linkedPromptTemplate?.promptID || "",

//           // Dynamic campaign info
//           campaignId: selectedCampaign._id,
//           leaderName: selectedCampaign.leaderName,
//           partyName: selectedCampaign.partyName,
//           manifesto: selectedCampaign.manifesto,
//           Constituency: selectedCampaign.Constituency,
//           ConstituencyTotalVoters: selectedCampaign.ConstituencyTotalVoters
//         };
//       });

//       const payload = { assignedAgentId: agentId, calls };

//       console.log("Sending payload:", payload);

//       try {
//         setIsCalling(true);
//         const token = localStorage.getItem("token");
//         if (!token) {
//           const error = new Error("No authentication token found");
//           console.error("Call Token Error:", error);
//           showNotification("error", error.message);
//           return;
//         }
//         console.log("Token exists for call:", !!token);

//         console.log("Making fetch request...");
//         const response = await fetch(
//           "https://prod.toxboxai.com/api/election-call/initiate-call",
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(payload),
//           }
//         );

//         console.log("Call response status:", response.status);

//         const result = await parseSSE(response);
//         console.log("Parsed SSE Result:", result);

//         if (result.success) {
//           console.log("Call success");
//           const callType = isBulk ? "bulk" : "single";
//           showNotification(
//             "success",
//             `Initiated ${callType} call${isBulk ? "s" : ""} for ${
//               calls.length
//             } voter${calls.length > 1 ? "s" : ""} successfully`
//           );
//           if (isBulk && selectionCount > 0) {
//             setSelectedVoters(new Set()); // Clear selection after bulk
//           }
//           // Optionally refresh campaigns
//           fetchCampaigns();
//         } else {
//           const errorMsg =
//             result.error || result.message || "Failed to initiate call";
//           console.error("Call API Error:", errorMsg);
//           showNotification("error", errorMsg);
//         }
//       } catch (error) {
//         console.error("Error initiating call:", error);
//         const errorMsg =
//           error.message || "Network error or invalid response occurred";
//         showNotification("error", errorMsg);
//       } finally {
//         setIsCalling(false);
//         console.log("Call complete");
//       }
//     },
//     [selectedAgent, showNotification, parseSSE, fetchCampaigns, selectionCount, selectedCampaign]
//   );

//   const handleSingleCall = useCallback(() => {
//     if (selectionCount !== 1) return;
//     const selectedVoter = Array.from(selectedVoters)
//       .map((id) => filteredVoters.find((v) => v._id === id))
//       .filter(Boolean)[0];
//     if (selectedVoter) {
//       initiateCall([selectedVoter], false);
//     }
//   }, [selectionCount, selectedVoters, filteredVoters, initiateCall]);

//   const handleBulkCall = useCallback(() => {
//     if (selectionCount === 0) return;
//     const selected = filteredVoters.filter((voter) =>
//       selectedVoters.has(voter._id)
//     );
//     initiateCall(selected, true);
//   }, [selectionCount, selectedVoters, filteredVoters, initiateCall]);

//   // Utility Functions
//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });

//   const getStatusBadge = (status) => {
//     const badges = {
//       not_called: { label: "Not Called", class: styles.statusNotCalled },
//       completed: { label: "Completed", class: styles.statusCompleted },
//       missed: { label: "Missed", class: styles.statusMissed },
//     };

//     const badge = badges[status] || badges.not_called;
//     return (
//       <span className={`${styles.statusBadge} ${badge.class}`}>
//         {badge.label}
//       </span>
//     );
//   };

//   const canCall = !!selectedAgent && selectionCount > 0;

//   const renderVoterContent = () => {
//     if (loading) {
//       return (
//         <div className={styles.loadingState}>
//           <div className={styles.spinner}></div>
//           <p>Loading...</p>
//         </div>
//       );
//     }

//     if (!selectedCampaign) {
//       return (
//         <div className={styles.emptyState}>
//           <div className={styles.emptyStateIcon}>🗳️</div>
//           <h2>Select a Campaign</h2>
//           <p>Choose a campaign to view voters and initiate calls</p>
//         </div>
//       );
//     }

//     if (filteredVoters.length === 0) {
//       return (
//         <div className={styles.emptyState}>
//           <div className={styles.emptyStateIcon}>🔍</div>
//           <h3>No voters found</h3>
//           <p>Try adjusting your search or filter criteria</p>
//         </div>
//       );
//     }

//     if (isMobile) {
//       // Card format for mobile
//       return (
//         <div className={styles.voterCards}>
//           {paginatedVoters.map((voter) => (
//             <div key={voter._id} className={styles.voterCard}>
//               <div className={styles.cardHeader}>
//                 <input
//                   type="checkbox"
//                   checked={selectedVoters.has(voter._id)}
//                   onChange={() => toggleVoterSelection(voter._id)}
//                   className={styles.checkbox}
//                   disabled={isCalling || loading}
//                 />
//                 <div className={styles.voterInfo}>
//                   <h4 className={styles.voterName}>
//                     {voter.voterName || "N/A"}
//                   </h4>
//                   <p className={styles.voterId}>ID: {voter.voterId || "N/A"}</p>
//                 </div>
//               </div>
//               <div className={styles.cardBody}>
//                 <p>
//                   <strong>Contact:</strong> {voter.voterContact || "N/A"}
//                 </p>
//                 <p className={styles.voterAddress}>
//                   <strong>Address:</strong> {voter.voterAddress || "N/A"}
//                 </p>
//                 <div className={styles.statusContainer}>
//                   <strong>Status:</strong> {getStatusBadge(voter.callStatus)}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       );
//     } else {
//       // Table format for desktop
//       return (
//         <div className={styles.voterTable}>
//           <table>
//             <thead>
//               <tr>
//                 <th>
//                   <input
//                     type="checkbox"
//                     checked={isAllSelected}
//                     onChange={toggleSelectAll}
//                     disabled={isCalling || loading}
//                   />
//                 </th>
//                 <th>Voter ID</th>
//                 <th>Name</th>
//                 <th>Contact</th>
//                 <th>Address</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedVoters.map((voter) => (
//                 <tr key={voter._id}>
//                   <td>
//                     <input
//                       type="checkbox"
//                       checked={selectedVoters.has(voter._id)}
//                       onChange={() => toggleVoterSelection(voter._id)}
//                       disabled={isCalling || loading}
//                     />
//                   </td>
//                   <td>{voter.voterId || "N/A"}</td>
//                   <td>{voter.voterName || "N/A"}</td>
//                   <td>{voter.voterContact || "N/A"}</td>
//                   <td className={styles.addressCell}>
//                     {voter.voterAddress || "N/A"}
//                   </td>
//                   <td>{getStatusBadge(voter.callStatus)}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       );
//     }
//   };

//   return (
//     <div className={styles.callerbook}>
//       {/* Notification */}
//       {notification.show && (
//         <div
//           className={`${styles.notification} ${styles[notification.type]} ${
//             styles.show
//           }`}
//         >
//           <div className={styles.notificationContent}>
//             <span className={styles.notificationIcon}>
//               {notification.type === "success" && "✅"}
//               {notification.type === "error" && "❌"}
//               {notification.type === "warning" && "⚠️"}
//               {notification.type === "info" && "ℹ️"}
//             </span>
//             <span className={styles.notificationMessage}>
//               {notification.message}
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Header */}
//       <header className={styles.header}>
//         <div className={styles.headerContent}>
//           <div className={styles.headerLeft}>
//             <h1 className={styles.title}>Election Caller Book</h1>
//             <p className={styles.subtitle}>
//               Initiate calls to voters efficiently
//             </p>
//           </div>
//         </div>
//       </header>

//       {/* Controls */}
//       <div className={styles.controls}>
//         <div className={styles.dropdownGroup}>
//           <div className={styles.formGroup}>
//             <label className={styles.label}>Select Campaign</label>
//             <select
//               value={selectedCampaign?._id || ""}
//               onChange={(e) => {
//                 const campaign = campaigns.find(
//                   (c) => c._id === e.target.value
//                 );
//                 setSelectedCampaign(campaign);
//               }}
//               className={styles.select}
//               disabled={loading}
//             >
//               <option value="">Choose a campaign...</option>
//               {campaigns.map((campaign) => (
//                 <option key={campaign._id} value={campaign._id}>
//                   {campaign.leaderName} - {campaign.partyName}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className={styles.formGroup}>
//             <label className={styles.label}>Select Agent</label>
//             <select
//               value={selectedAgent?._id || ""}
//               onChange={(e) => {
//                 const agent = agents.find((a) => a._id === e.target.value);
//                 setSelectedAgent(agent);
//               }}
//               className={styles.select}
//               disabled={loading}
//             >
//               <option value="">Choose an agent...</option>
//               {agents.map((agent) => (
//                 <option key={agent._id} value={agent._id}>
//                   {agent.avatarName} ({agent.language}, {agent.gender})
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Search and Filter */}
//         {selectedCampaign && (
//           <div className={styles.searchFilter}>
//             <div className={styles.searchBox}>
//               <input
//                 type="text"
//                 placeholder="Search voters..."
//                 value={searchTerm}
//                 onChange={(e) => {
//                   setSearchTerm(e.target.value);
//                   setCurrentPage(1);
//                 }}
//                 className={styles.searchInput}
//                 disabled={loading}
//               />
//             </div>
//             <select
//               value={statusFilter}
//               onChange={(e) => {
//                 setStatusFilter(e.target.value);
//                 setCurrentPage(1);
//               }}
//               className={styles.filterSelect}
//               disabled={loading}
//             >
//               <option value="all">All Status</option>
//               <option value="not_called">Not Called</option>
//               <option value="completed">Completed</option>
//               <option value="missed">Missed</option>
//             </select>
//           </div>
//         )}

//         {/* Call Buttons */}
//         {selectedCampaign && (
//           <div className={styles.callButtons}>
//             {selectionCount === 1 && canCall && (
//               <button
//                 className={styles.singleCallButton}
//                 onClick={handleSingleCall}
//                 disabled={isCalling || loading}
//               >
//                 📞 Single Call
//                 {isCalling && <span className={styles.spinner}></span>}
//               </button>
//             )}
//             {selectionCount > 1 && canCall && (
//               <button
//                 className={styles.bulkCallButton}
//                 onClick={handleBulkCall}
//                 disabled={isCalling || loading}
//               >
//                 📞 Bulk Call ({selectionCount})
//                 {isCalling && <span className={styles.spinner}></span>}
//               </button>
//             )}
//             {selectionCount > 0 && !canCall && (
//               <span className={styles.disabledMessage}>
//                 Select an agent to enable calls
//               </span>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Voter Content */}
//       {renderVoterContent()}

//       {/* Pagination - Only show on desktop or if not mobile */}
//       {!isMobile && totalPages > 1 && filteredVoters.length > 0 && (
//         <div className={styles.pagination}>
//           <button
//             onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//             disabled={currentPage === 1 || isCalling || loading}
//             className={styles.paginationButton}
//           >
//             ← Previous
//           </button>

//           <div className={styles.pageNumbers}>
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               const page = Math.max(1, currentPage - 2) + i;
//               if (page > totalPages) return null;

//               return (
//                 <button
//                   key={page}
//                   onClick={() => setCurrentPage(page)}
//                   disabled={isCalling || loading}
//                   className={`${styles.pageNumber} ${
//                     currentPage === page ? styles.active : ""
//                   }`}
//                 >
//                   {page}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             onClick={() =>
//               setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//             }
//             disabled={currentPage === totalPages || isCalling || loading}
//             className={styles.paginationButton}
//           >
//             Next →
//           </button>
//         </div>
//       )}

//       {/* Table Footer or Card Footer */}
//       {filteredVoters.length > 0 && (
//         <div className={styles.tableFooter}>
//           Showing {(currentPage - 1) * votersPerPage + 1} to{" "}
//           {Math.min(currentPage * votersPerPage, filteredVoters.length)} of{" "}
//           {filteredVoters.length} voters
//           {selectionCount > 0 && ` | Selected: ${selectionCount}`}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ElectionCallerbook;


// ElectionCallerbook.jsx
// ElectionCallerbook.jsx
// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import styles from "./Styles/ElectionCallerbook.module.css";

// const ElectionCallerbook = () => {
//   // State Management
//   const [campaigns, setCampaigns] = useState([]);
//   const [selectedCampaign, setSelectedCampaign] = useState(null);
//   const [promptAgents, setPromptAgents] = useState([]); // For agent/prompt types
//   const [selectedAgentId, setSelectedAgentId] = useState(null); // Selected agent ID
//   const [selectedPromptType, setSelectedPromptType] = useState(null); // Selected prompt type
//   const [selectedVoters, setSelectedVoters] = useState(new Set());
//   const [voters, setVoters] = useState([]); // Filtered and searched voters

//   // UI State
//   const [loading, setLoading] = useState(false);
//   const [isCalling, setIsCalling] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   // Search & Filter
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [currentPage, setCurrentPage] = useState(1);
//   const votersPerPage = 15;

//   // Notification State
//   const [notification, setNotification] = useState({
//     show: false,
//     type: "",
//     message: "",
//   });

//   // Detect mobile
//   useEffect(() => {
//     const mediaQuery = window.matchMedia("(max-width: 768px)");
//     setIsMobile(mediaQuery.matches);

//     const handler = (e) => setIsMobile(e.matches);
//     mediaQuery.addEventListener("change", handler);
//     return () => mediaQuery.removeEventListener("change", handler);
//   }, []);

//   // Effects
//   useEffect(() => {
//     console.log("Component mounted, fetching campaigns and prompt agents");
//     fetchCampaigns();
//     fetchPromptAgents();
//   }, []);

//   // Reset voters and selection when campaign changes
//   useEffect(() => {
//     if (selectedCampaign) {
//       console.log("Campaign selected:", selectedCampaign._id);
//       const volterList = selectedCampaign.volterList || [];
//       console.log("VolterList length:", volterList.length); // Debug log
//       setVoters(volterList);
//       setSelectedVoters(new Set());
//       setCurrentPage(1);
//       setSearchTerm("");
//       setStatusFilter("all");
//     } else {
//       console.log("No campaign selected, clearing voters");
//       setVoters([]);
//       setSelectedVoters(new Set());
//     }
//   }, [selectedCampaign]);

//   // Notification handler
//   const showNotification = useCallback((type, message) => {
//     console.log(`Showing notification: ${type} - ${message}`);
//     setNotification({ show: true, type, message });
//     setTimeout(
//       () => setNotification({ show: false, type: "", message: "" }),
//       4000
//     );
//   }, []);

//   // SSE Parser Function (adapted from CampaignManager)
//   const parseSSE = useCallback(async (response) => {
//     console.log("Parsing SSE response...");
//     if (!response.ok) {
//       const error = new Error(
//         `HTTP error! status: ${response.status} ${response.statusText}`
//       );
//       console.error("SSE HTTP Error:", error);
//       throw error;
//     }

//     if (!response.body) {
//       const error = new Error("ReadableStream not supported");
//       console.error("SSE ReadableStream Error:", error);
//       throw error;
//     }

//     const reader = response.body.getReader();
//     const decoder = new TextDecoder();
//     let fullResponse = "";

//     try {
//       console.log("Reading SSE stream...");
//       while (true) {
//         const { done, value } = await reader.read();
//         if (done) break;
//         fullResponse += decoder.decode(value, { stream: true });
//       }
//     } catch (readError) {
//       console.error("Error reading SSE stream:", readError);
//       throw readError;
//     } finally {
//       reader.releaseLock();
//     }

//     console.log("Full SSE Response:", fullResponse);

//     // Parse SSE events
//     const events = fullResponse.split("\n\n").filter((event) => event.trim());
//     console.log("Parsed SSE events count:", events.length);
//     let lastData = null;
//     let hasError = false;
//     let errorMessage = "";

//     for (const eventStr of events) {
//       const lines = eventStr.split("\n");
//       let eventType = "message"; // default
//       let data = "";

//       for (const line of lines) {
//         if (line.startsWith("event: ")) {
//           eventType = line.slice(7).trim();
//         } else if (line.startsWith("data: ")) {
//           data += line.slice(6) + "\n";
//         }
//       }

//       if (data.trim()) {
//         try {
//           const parsedData = JSON.parse(data.trim());
//           console.log(`Event ${eventType}:`, parsedData);
//           lastData = parsedData;
//           if (parsedData.error) {
//             hasError = true;
//             errorMessage = parsedData.error;
//             console.error("SSE Event Error:", parsedData.error);
//           }
//           if (parsedData.success !== undefined) {
//             if (parsedData.success) {
//               console.log("SSE Success Event:", parsedData);
//               return parsedData; // Return on success
//             } else {
//               hasError = true;
//               errorMessage = parsedData.message || "Call initiation failed";
//               console.error("SSE Failure Event:", parsedData);
//             }
//           }
//         } catch (parseError) {
//           console.error("Error parsing SSE data:", parseError, data);
//         }
//       }
//     }

//     // If error found in stream
//     if (hasError) {
//       const error = new Error(errorMessage);
//       console.error("SSE Stream Error:", error);
//       throw error;
//     }

//     // If no specific success/error found, return the last data or throw
//     if (lastData && lastData.success) {
//       console.log("SSE Last Data Success:", lastData);
//       return lastData;
//     } else {
//       const error = new Error(
//         "No valid data received from SSE stream or operation failed"
//       );
//       console.error("SSE No Valid Data:", error);
//       throw error;
//     }
//   }, []);

//   // API Functions
//   const fetchCampaigns = useCallback(async () => {
//     console.log("Fetching campaigns...");
//     try {
//       const creatorId = localStorage.getItem("userId");
//       console.log("Creator ID:", creatorId);
//       if (!creatorId) {
//         const error = new Error("No creator ID found in localStorage");
//         console.error("Fetch Campaigns Error:", error);
//         showNotification("error", error.message);
//         return;
//       }
//       setLoading(true);
//       const token = localStorage.getItem("token");
//       console.log("Token for fetch:", !!token);
//       if (!token) {
//         showNotification("error", "No authentication token found");
//         setLoading(false);
//         return;
//       }
//       const response = await fetch(
//         `https://prod.toxboxai.com/api/election-campaign/by-creator/${creatorId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       console.log("Fetch response status:", response.status);

//       if (!response.ok) {
//         const error = new Error(`HTTP error! status: ${response.status}`);
//         console.error("Fetch HTTP Error:", error);
//         showNotification("error", error.message);
//         return;
//       }

//       const result = await response.json();
//       console.log("Fetch result:", result);
//       console.log("Campaigns data length:", result.data ? result.data.length : 0); // Debug log
//       if (result.success) {
//         console.log("Campaigns fetched successfully:", result.data);
//         setCampaigns(result.data || []);
//       } else {
//         console.log("Fetch failed:", result.error);
//         showNotification("error", result.error || "Failed to fetch campaigns");
//       }
//     } catch (error) {
//       console.error("Error fetching campaigns:", error);
//       showNotification("error", error.message || "Network error occurred");
//     } finally {
//       setLoading(false);
//       console.log("Fetch campaigns complete");
//     }
//   }, [showNotification]);

//   const fetchPromptAgents = useCallback(async () => {
//     console.log("Fetching prompt agents...");
//     try {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         showNotification("error", "No authentication token found");
//         return;
//       }

//       const creatorId = localStorage.getItem("userId");
//       console.log("Creator ID:", creatorId);
//       if (!creatorId) {
//         const error = new Error("No creator ID found in localStorage");
//         console.error("Fetch Campaigns Error:", error);
//         showNotification("error", error.message);
//         return;
//       }
//       const response = await fetch(
//         `https://prod.toxboxai.com/api/election-agent/by-creator/${creatorId}`,
//         {
//           method: "GET",
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       console.log("Prompt agents response status:", response.status);

//       if (!response.ok) {
//         const error = new Error(`HTTP error! status: ${response.status}`);
//         console.error("Fetch Prompt Agents HTTP Error:", error);
//         showNotification("error", error.message);
//         return;
//       }

//       const result = await response.json();
//       console.log("Prompt agents fetch result:", result);
//       if (result.data) {
//         console.log("Prompt agents fetched successfully:", result.data);
//         setPromptAgents(result.data);
//       } else {
//         console.log("Fetch prompt agents failed:", result);
//         showNotification("error", "Failed to fetch prompt agents");
//       }
//     } catch (error) {
//       console.error("Error fetching prompt agents:", error);
//       showNotification("error", error.message || "Network error occurred");
//     }
//   }, [showNotification]);

//   // Filter and Search Voters
//   const getFilteredVoters = useCallback(() => {
//     console.log("Getting filtered voters...");
//     console.log("Current voters length:", voters.length); // Debug log
//     let filtered = [...voters];

//     // Optional: Filter by selected prompt type if agent is selected
//     if (selectedPromptType) {
//       console.log("Applying prompt type filter:", selectedPromptType);
//       filtered = filtered.filter(voter => voter.type === selectedPromptType);
//     }

//     // Apply search filter
//     if (searchTerm) {
//       console.log("Applying search filter:", searchTerm);
//       const search = searchTerm.toLowerCase();
//       filtered = filtered.filter(
//         (voter) =>
//           voter.voterName?.toLowerCase().includes(search) ||
//           voter.voterId?.toLowerCase().includes(search) ||
//           voter.voterContact?.toLowerCase().includes(search) ||
//           voter.voterAddress?.toLowerCase().includes(search)
//       );
//     }

//     // Apply status filter
//     if (statusFilter !== "all") {
//       console.log("Applying status filter:", statusFilter);
//       filtered = filtered.filter((voter) => voter.callStatus === statusFilter);
//     }

//     console.log(`Filtered voters count: ${filtered.length}`);
//     return filtered;
//   }, [voters, searchTerm, statusFilter, selectedPromptType]);

//   const filteredVoters = getFilteredVoters();
//   const paginatedVoters = useMemo(() => {
//     const startIndex = (currentPage - 1) * votersPerPage;
//     return filteredVoters.slice(startIndex, startIndex + votersPerPage);
//   }, [filteredVoters, currentPage, votersPerPage]);
//   const totalPages = Math.ceil(filteredVoters.length / votersPerPage);
//   const isAllSelected =
//     filteredVoters.length > 0 &&
//     filteredVoters.every((voter) => selectedVoters.has(voter._id));
//   const selectionCount = selectedVoters.size;

//   // Get progressed voters for steppers (type 'promise' and status 'completed')
//   const progressedVoters = useMemo(() => {
//     const progressed = voters.filter(voter => voter.type === 'promise' && voter.callStatus === 'completed');
//     console.log("Progressed voters count:", progressed.length); // Debug log
//     return progressed;
//   }, [voters]);

//   // Selection Management
//   const toggleVoterSelection = useCallback((voterId) => {
//     console.log("Toggling selection for voter:", voterId);
//     setSelectedVoters((prev) => {
//       const newSelection = new Set(prev);
//       if (newSelection.has(voterId)) {
//         newSelection.delete(voterId);
//         console.log("Deselected voter:", voterId);
//       } else {
//         newSelection.add(voterId);
//         console.log("Selected voter:", voterId);
//       }
//       console.log("New selection size:", newSelection.size);
//       return newSelection;
//     });
//   }, []);

//   const toggleSelectAll = useCallback(() => {
//     const allSelected = filteredVoters.every((voter) =>
//       selectedVoters.has(voter._id)
//     );
//     console.log(
//       "Toggle select all: allSelected?",
//       allSelected,
//       "filtered count:",
//       filteredVoters.length
//     );

//     if (allSelected) {
//       setSelectedVoters(new Set());
//       console.log("Deselected all");
//     } else {
//       setSelectedVoters(new Set(filteredVoters.map((v) => v._id)));
//       console.log("Selected all");
//     }
//   }, [filteredVoters, selectedVoters]);

//   // Handle agent selection
//   const handleAgentSelect = useCallback((e) => {
//     const promptType = e.target.value;
//     const selected = promptAgents.find(item => item.promptType === promptType);
//     if (selected) {
//       if (!selected.agentId) {
//         showNotification("warning", `You have not created an agent for the ${promptType} prompt type. Please create one first.`);
//         setSelectedAgentId(null);
//         setSelectedPromptType(null);
//         return;
//       }
//       setSelectedAgentId(selected.agentId);
//       setSelectedPromptType(promptType);
//       console.log(`Selected agent for ${promptType}: ${selected.agentId}`);
//     } else {
//       setSelectedAgentId(null);
//       setSelectedPromptType(null);
//     }
//   }, [promptAgents, showNotification]);

//   // Call Management (adapted from CampaignManager)
//   const initiateCall = useCallback(
//     async (votersToCall, isBulk = false) => {
//       console.log(
//         `${isBulk ? "Bulk" : "Single"} call initiated for ${
//           votersToCall.length
//         } voters`
//       );

//       if (votersToCall.length === 0) {
//         showNotification("warning", "No voters selected for calling");
//         return;
//       }

//       if (!selectedAgentId) {
//         showNotification("error", "Please select an agent first");
//         return;
//       }

//       // Validate and build calls array
//       const validVoters = votersToCall.filter((voter) => {
//         let contact = voter.voterContact;
//         if (contact && !contact.startsWith("+")) {
//           contact = "+" + contact.replace(/[\s-]/g, "");
//         }
//         if (!contact || !contact.trim()) {
//           console.warn(`Voter ${voter.voterName} skipped: No contact number`);
//           return false;
//         }
//         // Basic phone validation (starts with + and digits)
//         if (!/^\+\d{10,15}$/.test(contact)) {
//           console.warn(
//             `Voter ${voter.voterName} skipped: Invalid contact format after normalization: ${contact}`
//           );
//           return false;
//         }
//         if (!voter._id || !voter.type) {
//           console.warn(`Voter ${voter.voterName} skipped: Missing ID or type`);
//           return false;
//         }
//         return true;
//       });

//       console.log("Valid Voters:", validVoters);

//       if (validVoters.length === 0) {
//         showNotification(
//           "warning",
//           "No valid voters with contact numbers selected"
//         );
//         return;
//       }

//       // Build calls array with dynamic campaign data per voter
//       const cleanPhoneNumber = (phone) => phone.replace(/[+\s-()]/g, "");
//       const calls = validVoters.map((voter) => {
//         let contact = voter.voterContact;
//         if (contact && !contact.startsWith("+")) {
//           contact = "+" + contact.replace(/[\s-]/g, "");
//         }
//         return {
//           toNumber: cleanPhoneNumber(contact),
//           fromNumber: "8035738038",
//           customerName: voter.voterName || "Unknown",
//           type: voter.type,
//           voterId: voter._id,
//           promptId: voter.linkedPromptTemplate?.promptID || "",

//           // Dynamic campaign info
//           campaignId: selectedCampaign._id,
//           leaderName: selectedCampaign.leaderName,
//           partyName: selectedCampaign.partyName,
//           manifesto: selectedCampaign.manifesto,
//           Constituency: selectedCampaign.Constituency,
//           ConstituencyTotalVoters: selectedCampaign.ConstituencyTotalVoters
//         };
//       });

//       const payload = { assignedAgentId: selectedAgentId, calls };

//       console.log("Sending payload:", payload);

//       try {
//         setIsCalling(true);
//         const token = localStorage.getItem("token");
//         if (!token) {
//           const error = new Error("No authentication token found");
//           console.error("Call Token Error:", error);
//           showNotification("error", error.message);
//           return;
//         }
//         console.log("Token exists for call:", !!token);

//         console.log("Making fetch request...");
//         const response = await fetch(
//           "https://prod.toxboxai.com/api/election-call/initiate-call",
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(payload),
//           }
//         );

//         console.log("Call response status:", response.status);

//         const result = await parseSSE(response);
//         console.log("Parsed SSE Result:", result);

//         if (result.success) {
//           console.log("Call success");
//           const callType = isBulk ? "bulk" : "single";
//           showNotification(
//             "success",
//             `Initiated ${callType} call${isBulk ? "s" : ""} for ${
//               calls.length
//             } voter${calls.length > 1 ? "s" : ""} successfully`
//           );
//           if (isBulk && selectionCount > 0) {
//             setSelectedVoters(new Set()); // Clear selection after bulk
//           }
//           // Optionally refresh campaigns
//           fetchCampaigns();
//         } else {
//           const errorMsg =
//             result.error || result.message || "Failed to initiate call";
//           console.error("Call API Error:", errorMsg);
//           showNotification("error", errorMsg);
//         }
//       } catch (error) {
//         console.error("Error initiating call:", error);
//         const errorMsg =
//           error.message || "Network error or invalid response occurred";
//         showNotification("error", errorMsg);
//       } finally {
//         setIsCalling(false);
//         console.log("Call complete");
//       }
//     },
//     [selectedAgentId, showNotification, parseSSE, fetchCampaigns, selectionCount, selectedCampaign]
//   );

//   const handleSingleCall = useCallback(() => {
//     if (selectionCount !== 1) return;
//     const selectedVoter = Array.from(selectedVoters)
//       .map((id) => filteredVoters.find((v) => v._id === id))
//       .filter(Boolean)[0];
//     if (selectedVoter) {
//       initiateCall([selectedVoter], false);
//     }
//   }, [selectionCount, selectedVoters, filteredVoters, initiateCall]);

//   const handleBulkCall = useCallback(() => {
//     if (selectionCount === 0) return;
//     const selected = filteredVoters.filter((voter) =>
//       selectedVoters.has(voter._id)
//     );
//     initiateCall(selected, true);
//   }, [selectionCount, selectedVoters, filteredVoters, initiateCall]);

//   // Utility Functions
//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });

//   const getStatusBadge = (status) => {
//     const badges = {
//       not_called: { label: "Not Called", class: styles.statusNotCalled },
//       completed: { label: "Completed", class: styles.statusCompleted },
//       missed: { label: "Missed", class: styles.statusMissed },
//     };

//     const badge = badges[status] || badges.not_called;
//     return (
//       <span className={`${styles.statusBadge} ${badge.class}`}>
//         {badge.label}
//       </span>
//     );
//   };

//   const canCall = !!selectedAgentId && selectionCount > 0;

//   const renderStepper = (voter) => (
//     <div key={voter._id} className={styles.stepper}>
//       <h4>{voter.voterName} - {voter.voterId}</h4>
//       <div className={styles.stepContainer}>
//         <div className={styles.step} style={{ backgroundColor: '#10b981' }}> {/* Completed Query */}
//           <span>Query Call Completed</span>
//           <p>{voter.voterContact} | {voter.voterAddress}</p>
//         </div>
//         <div className={styles.stepArrow}>→</div>
//         <div className={styles.step} style={{ backgroundColor: '#f59e0b' }}> {/* Promise Stage */}
//           <span>Promise Follow-up</span>
//           <p>Updated ID: {voter._id} | Type: {voter.type}</p>
//         </div>
//       </div>
//     </div>
//   );

//   const renderVoterContent = () => {
//     console.log("Rendering voter content - filteredVoters length:", filteredVoters.length); // Debug log
//     console.log("Progressed voters length:", progressedVoters.length); // Debug log
//     if (loading) {
//       return (
//         <div className={styles.loadingState}>
//           <div className={styles.spinner}></div>
//           <p>Loading...</p>
//         </div>
//       );
//     }

//     if (!selectedCampaign) {
//       return (
//         <div className={styles.emptyState}>
//           <div className={styles.emptyStateIcon}>🗳️</div>
//           <h2>Select a Campaign</h2>
//           <p>Choose a campaign to view voters and initiate calls</p>
//         </div>
//       );
//     }

//     if (filteredVoters.length === 0) {
//       return (
//         <div className={styles.emptyState}>
//           <div className={styles.emptyStateIcon}>🔍</div>
//           <h3>No voters found</h3>
//           <p>Try adjusting your search or filter criteria. Voters length: {voters.length}</p> {/* Debug */}
//         </div>
//       );
//     }

//     return (
//       <>
//         {/* Progress Steppers Section */}
//         {/* {progressedVoters.length > 0 && (
//           <div className={styles.progressSection}>
//             <h3>Progress Steppers (Type Changes)</h3>
//             {progressedVoters.map(renderStepper)}
//           </div>
//         )} */}

//         {isMobile ? (
//           // Card format for mobile
//           <div className={styles.voterCards}>
//             {paginatedVoters.map((voter) => (
//               <div key={voter._id} className={styles.voterCard}>
//                 <div className={styles.cardHeader}>
//                   <input
//                     type="checkbox"
//                     checked={selectedVoters.has(voter._id)}
//                     onChange={() => toggleVoterSelection(voter._id)}
//                     className={styles.checkbox}
//                     disabled={isCalling || loading}
//                   />
//                   <div className={styles.voterInfo}>
//                     <h4 className={styles.voterName}>
//                       {voter.voterName || "N/A"}
//                     </h4>
//                     <p className={styles.voterId}>ID: {voter.voterId || "N/A"}</p>
//                   </div>
//                 </div>
//                 <div className={styles.cardBody}>
//                   <p>
//                     <strong>Contact:</strong> {voter.voterContact || "N/A"}
//                   </p>
//                   <p className={styles.voterAddress}>
//                     <strong>Address:</strong> {voter.voterAddress || "N/A"}
//                   </p>
//                   <div className={styles.statusContainer}>
//                     <strong>Status:</strong> {getStatusBadge(voter.callStatus)}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           // Table format for desktop
//           <div className={styles.voterTable}>
//             <table>
//               <thead>
//                 <tr>
//                   <th>
//                     <input
//                       type="checkbox"
//                       checked={isAllSelected}
//                       onChange={toggleSelectAll}
//                       disabled={isCalling || loading}
//                     />
//                   </th>
//                   <th>Voter ID</th>
//                   <th>Name</th>
//                   <th>Contact</th>
//                   <th>Address</th>
//                   <th>Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedVoters.map((voter) => (
//                   <tr key={voter._id}>
//                     <td>
//                       <input
//                         type="checkbox"
//                         checked={selectedVoters.has(voter._id)}
//                         onChange={() => toggleVoterSelection(voter._id)}
//                         disabled={isCalling || loading}
//                       />
//                     </td>
//                     <td>{voter.voterId || "N/A"}</td>
//                     <td>{voter.voterName || "N/A"}</td>
//                     <td>{voter.voterContact || "N/A"}</td>
//                     <td className={styles.addressCell}>
//                       {voter.voterAddress || "N/A"}
//                     </td>
//                     <td>{getStatusBadge(voter.callStatus)}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </>
//     );
//   };

//   return (
//     <div className={styles.callerbook}>
//       {/* Notification */}
//       {notification.show && (
//         <div
//           className={`${styles.notification} ${styles[notification.type]} ${
//             styles.show
//           }`}
//         >
//           <div className={styles.notificationContent}>
//             <span className={styles.notificationIcon}>
//               {notification.type === "success" && "✅"}
//               {notification.type === "error" && "❌"}
//               {notification.type === "warning" && "⚠️"}
//               {notification.type === "info" && "ℹ️"}
//             </span>
//             <span className={styles.notificationMessage}>
//               {notification.message}
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Header */}
//       <header className={styles.header}>
//         <div className={styles.headerContent}>
//           <div className={styles.headerLeft}>
//             <h1 className={styles.title}>Election Caller Book</h1>
//             <p className={styles.subtitle}>
//               Initiate calls to voters efficiently
//             </p>
//           </div>
//         </div>
//       </header>

//       {/* Controls */}
//       <div className={styles.controls}>
//         <div className={styles.dropdownGroup}>
//           <div className={styles.formGroup}>
//             <label className={styles.label}>Select Campaign</label>
//             <select
//               value={selectedCampaign?._id || ""}
//               onChange={(e) => {
//                 const campaign = campaigns.find(
//                   (c) => c._id === e.target.value
//                 );
//                 console.log("Selected campaign:", campaign); // Debug log
//                 setSelectedCampaign(campaign);
//               }}
//               className={styles.select}
//               disabled={loading}
//             >
//               <option value="">Choose a campaign...</option>
//               {campaigns.map((campaign) => (
//                 <option key={campaign._id} value={campaign._id}>
//                   {campaign.leaderName} - {campaign.partyName}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className={styles.formGroup}>
//             <label className={styles.label}>Select Agent (Prompt Type)</label>
//             <select
//               value={selectedPromptType || ""}
//               onChange={handleAgentSelect}
//               className={styles.select}
//               disabled={loading}
//             >
//               <option value="">Choose a prompt type...</option>
//               {promptAgents.map((item) => (
//                 <option key={item.promptType} value={item.promptType}>
//                   {item.promptName} ({item.promptType}) {item.agentName ? `- Agent: ${item.agentName}` : '(No Agent Created)'}
//                 </option>
//               ))}
//             </select>
//             {promptAgents.some(item => !item.agentId && item.promptType !== 'query' && item.promptType !== 'promise') && (
//               <p className={styles.agentNote}>
//                 Note: Agents need to be created for Leader, Party, Influencer, and Custom prompt types to enable calls.
//               </p>
//             )}
//           </div>
//         </div>

//         {/* Search and Filter */}
//         {selectedCampaign && (
//           <div className={styles.searchFilter}>
//             <div className={styles.searchBox}>
//               <input
//                 type="text"
//                 placeholder="Search voters..."
//                 value={searchTerm}
//                 onChange={(e) => {
//                   setSearchTerm(e.target.value);
//                   setCurrentPage(1);
//                 }}
//                 className={styles.searchInput}
//                 disabled={loading}
//               />
//             </div>
//             <select
//               value={statusFilter}
//               onChange={(e) => {
//                 setStatusFilter(e.target.value);
//                 setCurrentPage(1);
//               }}
//               className={styles.filterSelect}
//               disabled={loading}
//             >
//               <option value="all">All Status</option>
//               <option value="not_called">Not Called</option>
//               <option value="completed">Completed</option>
//               <option value="missed">Missed</option>
//             </select>
//           </div>
//         )}

//         {/* Call Buttons */}
//         {selectedCampaign && (
//           <div className={styles.callButtons}>
//             {selectionCount === 1 && canCall && (
//               <button
//                 className={styles.singleCallButton}
//                 onClick={handleSingleCall}
//                 disabled={isCalling || loading}
//               >
//                 📞 Single Call
//                 {isCalling && <span className={styles.spinner}></span>}
//               </button>
//             )}
//             {selectionCount > 1 && canCall && (
//               <button
//                 className={styles.bulkCallButton}
//                 onClick={handleBulkCall}
//                 disabled={isCalling || loading}
//               >
//                 📞 Bulk Call ({selectionCount})
//                 {isCalling && <span className={styles.spinner}></span>}
//               </button>
//             )}
//             {selectionCount > 0 && !canCall && (
//               <span className={styles.disabledMessage}>
//                 Select an agent and voters to enable calls
//               </span>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Voter Content */}
//       {renderVoterContent()}

//       {/* Pagination - Only show on desktop or if not mobile */}
//       {!isMobile && totalPages > 1 && filteredVoters.length > 0 && (
//         <div className={styles.pagination}>
//           <button
//             onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//             disabled={currentPage === 1 || isCalling || loading}
//             className={styles.paginationButton}
//           >
//             ← Previous
//           </button>

//           <div className={styles.pageNumbers}>
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               const page = Math.max(1, currentPage - 2) + i;
//               if (page > totalPages) return null;

//               return (
//                 <button
//                   key={page}
//                   onClick={() => setCurrentPage(page)}
//                   disabled={isCalling || loading}
//                   className={`${styles.pageNumber} ${
//                     currentPage === page ? styles.active : ""
//                   }`}
//                 >
//                   {page}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             onClick={() =>
//               setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//             }
//             disabled={currentPage === totalPages || isCalling || loading}
//             className={styles.paginationButton}
//           >
//             Next →
//           </button>
//         </div>
//       )}

//       {/* Table Footer or Card Footer */}
//       {filteredVoters.length > 0 && (
//         <div className={styles.tableFooter}>
//           Showing {(currentPage - 1) * votersPerPage + 1} to{" "}
//           {Math.min(currentPage * votersPerPage, filteredVoters.length)} of{" "}
//           {filteredVoters.length} voters
//           {selectionCount > 0 && ` | Selected: ${selectionCount}`}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ElectionCallerbook; 






import React, { useState, useEffect, useCallback, useMemo } from "react";
import styles from "./Styles/ElectionCallerbook.module.css";

const ElectionCallerbook = () => {
  // State Management
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [promptAgents, setPromptAgents] = useState([]); // For agent/prompt types
  const [selectedAgentId, setSelectedAgentId] = useState(null); // Selected agent ID
  const [selectedPromptType, setSelectedPromptType] = useState(null); // Selected prompt type
  const [selectedVoters, setSelectedVoters] = useState(new Set());
  const [voters, setVoters] = useState([]); // Filtered and searched voters

  // UI State
  const [loading, setLoading] = useState(false);
  const [isCalling, setIsCalling] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Search & Filter
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const votersPerPage = 15;

  // Notification State
  const [notification, setNotification] = useState({
    show: false,
    type: "",
    message: "",
  });

  // Detect mobile
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    setIsMobile(mediaQuery.matches);

    const handler = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  // Effects
  useEffect(() => {
    console.log("Component mounted, fetching campaigns and prompt agents");
    fetchCampaigns();
    fetchPromptAgents();
  }, []);

  // Reset voters and selection when campaign changes
  useEffect(() => {
    if (selectedCampaign) {
      console.log("Campaign selected:", selectedCampaign._id);
      const volterList = selectedCampaign.volterList || [];
      console.log("VolterList length:", volterList.length); // Debug log
      setVoters(volterList);
      setSelectedVoters(new Set());
      setCurrentPage(1);
      setSearchTerm("");
      setStatusFilter("all");
    } else {
      console.log("No campaign selected, clearing voters");
      setVoters([]);
      setSelectedVoters(new Set());
    }
  }, [selectedCampaign]);

  // Notification handler
  const showNotification = useCallback((type, message) => {
    console.log(`Showing notification: ${type} - ${message}`);
    setNotification({ show: true, type, message });
    setTimeout(
      () => setNotification({ show: false, type: "", message: "" }),
      4000
    );
  }, []);

  // SSE Parser Function (adapted from CampaignManager)
  const parseSSE = useCallback(async (response) => {
    console.log("Parsing SSE response...");
    if (!response.ok) {
      const error = new Error(
        `HTTP error! status: ${response.status} ${response.statusText}`
      );
      console.error("SSE HTTP Error:", error);
      throw error;
    }

    if (!response.body) {
      const error = new Error("ReadableStream not supported");
      console.error("SSE ReadableStream Error:", error);
      throw error;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let fullResponse = "";

    try {
      console.log("Reading SSE stream...");
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        fullResponse += decoder.decode(value, { stream: true });
      }
    } catch (readError) {
      console.error("Error reading SSE stream:", readError);
      throw readError;
    } finally {
      reader.releaseLock();
    }

    console.log("Full SSE Response:", fullResponse);

    // Parse SSE events
    const events = fullResponse.split("\n\n").filter((event) => event.trim());
    console.log("Parsed SSE events count:", events.length);
    let lastData = null;
    let hasError = false;
    let errorMessage = "";

    for (const eventStr of events) {
      const lines = eventStr.split("\n");
      let eventType = "message"; // default
      let data = "";

      for (const line of lines) {
        if (line.startsWith("event: ")) {
          eventType = line.slice(7).trim();
        } else if (line.startsWith("data: ")) {
          data += line.slice(6) + "\n";
        }
      }

      if (data.trim()) {
        try {
          const parsedData = JSON.parse(data.trim());
          console.log(`Event ${eventType}:`, parsedData);
          lastData = parsedData;
          if (parsedData.error) {
            hasError = true;
            errorMessage = parsedData.error;
            console.error("SSE Event Error:", parsedData.error);
          }
          if (parsedData.success !== undefined) {
            if (parsedData.success) {
              console.log("SSE Success Event:", parsedData);
              return parsedData; // Return on success
            } else {
              hasError = true;
              errorMessage = parsedData.message || "Call initiation failed";
              console.error("SSE Failure Event:", parsedData);
            }
          }
        } catch (parseError) {
          console.error("Error parsing SSE data:", parseError, data);
        }
      }
    }

    // If error found in stream
    if (hasError) {
      const error = new Error(errorMessage);
      console.error("SSE Stream Error:", error);
      throw error;
    }

    // If no specific success/error found, return the last data or throw
    if (lastData && lastData.success) {
      console.log("SSE Last Data Success:", lastData);
      return lastData;
    } else {
      const error = new Error(
        "No valid data received from SSE stream or operation failed"
      );
      console.error("SSE No Valid Data:", error);
      throw error;
    }
  }, []);

  // API Functions
  const fetchCampaigns = useCallback(async () => {
    console.log("Fetching campaigns...");
    try {
      const creatorId = localStorage.getItem("userId");
      console.log("Creator ID:", creatorId);
      if (!creatorId) {
        const error = new Error("No creator ID found in localStorage");
        console.error("Fetch Campaigns Error:", error);
        showNotification("error", error.message);
        return;
      }
      setLoading(true);
      const token = localStorage.getItem("token");
      console.log("Token for fetch:", !!token);
      if (!token) {
        showNotification("error", "No authentication token found");
        setLoading(false);
        return;
      }
      const response = await fetch(
        `https://prod.toxboxai.com/api/election-campaign/by-creator/${creatorId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log("Fetch response status:", response.status);

      if (!response.ok) {
        const error = new Error(`HTTP error! status: ${response.status}`);
        console.error("Fetch HTTP Error:", error);
        showNotification("error", error.message);
        return;
      }

      const result = await response.json();
      console.log("Fetch result:", result);
      console.log("Campaigns data length:", result.data ? result.data.length : 0); // Debug log
      if (result.success) {
        console.log("Campaigns fetched successfully:", result.data);
        setCampaigns(result.data || []);
      } else {
        console.log("Fetch failed:", result.error);
        showNotification("error", result.error || "Failed to fetch campaigns");
      }
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      showNotification("error", error.message || "Network error occurred");
    } finally {
      setLoading(false);
      console.log("Fetch campaigns complete");
    }
  }, [showNotification]);

  const fetchPromptAgents = useCallback(async () => {
    console.log("Fetching prompt agents...");
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        showNotification("error", "No authentication token found");
        return;
      }
      const response = await fetch(
        "https://prod.toxboxai.com/api/election-agent/prompt-template/get-prompt-type-with-agent",
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log("Prompt agents response status:", response.status);

      if (!response.ok) {
        const error = new Error(`HTTP error! status: ${response.status}`);
        console.error("Fetch Prompt Agents HTTP Error:", error);
        showNotification("error", error.message);
        return;
      }

      const result = await response.json();
      console.log("Prompt agents fetch result:", result);
      if (result.data) {
        console.log("Prompt agents fetched successfully:", result.data);
        setPromptAgents(result.data);
      } else {
        console.log("Fetch prompt agents failed:", result);
        showNotification("error", "Failed to fetch prompt agents");
      }
    } catch (error) {
      console.error("Error fetching prompt agents:", error);
      showNotification("error", error.message || "Network error occurred");
    }
  }, [showNotification]);

  // Filter and Search Voters
  const getFilteredVoters = useCallback(() => {
    console.log("Getting filtered voters...");
    console.log("Current voters length:", voters.length); // Debug log
    let filtered = [...voters];

    // Optional: Filter by selected prompt type if agent is selected
    if (selectedPromptType) {
      console.log("Applying prompt type filter:", selectedPromptType);
      filtered = filtered.filter(voter => voter.type === selectedPromptType);
    }

    // Apply search filter
    if (searchTerm) {
      console.log("Applying search filter:", searchTerm);
      const search = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (voter) =>
          voter.voterName?.toLowerCase().includes(search) ||
          voter.voterId?.toLowerCase().includes(search) ||
          voter.voterContact?.toLowerCase().includes(search) ||
          voter.voterAddress?.toLowerCase().includes(search)
      );
    }

    // Apply status filter
    if (statusFilter !== "all") {
      console.log("Applying status filter:", statusFilter);
      filtered = filtered.filter((voter) => voter.callStatus === statusFilter);
    }

    console.log(`Filtered voters count: ${filtered.length}`);
    return filtered;
  }, [voters, searchTerm, statusFilter, selectedPromptType]);

  const filteredVoters = getFilteredVoters();
  const paginatedVoters = useMemo(() => {
    const startIndex = (currentPage - 1) * votersPerPage;
    return filteredVoters.slice(startIndex, startIndex + votersPerPage);
  }, [filteredVoters, currentPage, votersPerPage]);
  const totalPages = Math.ceil(filteredVoters.length / votersPerPage);
  const isAllSelected =
    filteredVoters.length > 0 &&
    filteredVoters.every((voter) => selectedVoters.has(voter._id));
  const selectionCount = selectedVoters.size;

  // Get progressed voters for steppers (type 'promise' and status 'completed')
  const progressedVoters = useMemo(() => {
    const progressed = voters.filter(voter => voter.type === 'promise' && voter.callStatus === 'completed');
    console.log("Progressed voters count:", progressed.length); // Debug log
    return progressed;
  }, [voters]);

  // Selection Management
  const toggleVoterSelection = useCallback((voterId) => {
    console.log("Toggling selection for voter:", voterId);
    setSelectedVoters((prev) => {
      const newSelection = new Set(prev);
      if (newSelection.has(voterId)) {
        newSelection.delete(voterId);
        console.log("Deselected voter:", voterId);
      } else {
        newSelection.add(voterId);
        console.log("Selected voter:", voterId);
      }
      console.log("New selection size:", newSelection.size);
      return newSelection;
    });
  }, []);

  const toggleSelectAll = useCallback(() => {
    const allSelected = filteredVoters.every((voter) =>
      selectedVoters.has(voter._id)
    );
    console.log(
      "Toggle select all: allSelected?",
      allSelected,
      "filtered count:",
      filteredVoters.length
    );

    if (allSelected) {
      setSelectedVoters(new Set());
      console.log("Deselected all");
    } else {
      setSelectedVoters(new Set(filteredVoters.map((v) => v._id)));
      console.log("Selected all");
    }
  }, [filteredVoters, selectedVoters]);

  // Handle agent selection
  const handleAgentSelect = useCallback((e) => {
    const promptType = e.target.value;
    const selected = promptAgents.find(item => item.promptType === promptType);
    if (selected) {
      if (!selected.agentId) {
        showNotification("warning", `You have not created an agent for the ${promptType} prompt type. Please create one first.`);
        setSelectedAgentId(null);
        setSelectedPromptType(null);
        return;
      }
      setSelectedAgentId(selected.agentId);
      setSelectedPromptType(promptType);
      console.log(`Selected agent for ${promptType}: ${selected.agentId}`);
    } else {
      setSelectedAgentId(null);
      setSelectedPromptType(null);
    }
  }, [promptAgents, showNotification]);

  // Call Management (adapted from CampaignManager)
  const initiateCall = useCallback(
    async (votersToCall, isBulk = false) => {
      console.log(
        `${isBulk ? "Bulk" : "Single"} call initiated for ${votersToCall.length
        } voters`
      );

      if (votersToCall.length === 0) {
        showNotification("warning", "No voters selected for calling");
        return;
      }

      if (!selectedAgentId) {
        showNotification("error", "Please select an agent first");
        return;
      }

      // Validate and build calls array
      const validVoters = votersToCall.filter((voter) => {
        let contact = voter.voterContact;
        if (contact && !contact.startsWith("+")) {
          contact = "+" + contact.replace(/[\s-]/g, "");
        }
        if (!contact || !contact.trim()) {
          console.warn(`Voter ${voter.voterName} skipped: No contact number`);
          return false;
        }
        // Basic phone validation (starts with + and digits)
        if (!/^\+\d{10,15}$/.test(contact)) {
          console.warn(
            `Voter ${voter.voterName} skipped: Invalid contact format after normalization: ${contact}`
          );
          return false;
        }
        if (!voter._id || !voter.type) {
          console.warn(`Voter ${voter.voterName} skipped: Missing ID or type`);
          return false;
        }
        return true;
      });

      console.log("Valid Voters:", validVoters);

      if (validVoters.length === 0) {
        showNotification(
          "warning",
          "No valid voters with contact numbers selected"
        );
        return;
      }

      // Build calls array with dynamic campaign data per voter
      const cleanPhoneNumber = (phone) => phone.replace(/[+\s-()]/g, "");
      const calls = validVoters.map((voter) => {
        let contact = voter.voterContact;
        // if (contact && !contact.startsWith("+")) {
        //   contact = "+" + contact.replace(/[\s-]/g, "");
        // }
        return {
          toNumber: cleanPhoneNumber(contact),
          fromNumber: "8035738038",
          customerName: voter.voterName || "Unknown",
          type: voter.type,
          voterId: voter._id,
          promptId: voter.linkedPromptTemplate?.promptID || "",

          // Dynamic campaign info
          campaignId: selectedCampaign._id,
          leaderName: selectedCampaign.leaderName,
          partyName: selectedCampaign.partyName,
          manifesto: selectedCampaign.manifesto,
          Constituency: selectedCampaign.Constituency,
          ConstituencyTotalVoters: selectedCampaign.ConstituencyTotalVoters
        };
      });

      const payload = { assignedAgentId: selectedAgentId, calls, campaignId: selectedCampaign._id };

      console.log("Sending payload:", payload);

      try {
        setIsCalling(true);
        const token = localStorage.getItem("token");
        if (!token) {
          const error = new Error("No authentication token found");
          console.error("Call Token Error:", error);
          showNotification("error", error.message);
          return;
        }
        console.log("Token exists for call:", !!token);

        console.log("Making fetch request...");
        const response = await fetch(
          "https://prod.toxboxai.com/api/election-call/initiate-call",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        console.log("Call response status:", response.status);

        const result = await parseSSE(response);
        console.log("Parsed SSE Result:", result);

        if (result.success) {
          console.log("Call success");
          const callType = isBulk ? "bulk" : "single";
          showNotification(
            "success",
            `Initiated ${callType} call${isBulk ? "s" : ""} for ${calls.length
            } voter${calls.length > 1 ? "s" : ""} successfully`
          );
          if (isBulk && selectionCount > 0) {
            setSelectedVoters(new Set()); // Clear selection after bulk
          }
          // Optionally refresh campaigns
          fetchCampaigns();
        } else {
          const errorMsg =
            result.error || result.message || "Failed to initiate call";
          console.error("Call API Error:", errorMsg);
          showNotification("error", errorMsg);
        }
      } catch (error) {
        console.error("Error initiating call:", error);
        const errorMsg =
          error.message || "Network error or invalid response occurred";
        showNotification("error", errorMsg);
      } finally {
        setIsCalling(false);
        console.log("Call complete");
      }
    },
    [selectedAgentId, showNotification, parseSSE, fetchCampaigns, selectionCount, selectedCampaign]
  );

  const handleSingleCall = useCallback(() => {
    if (selectionCount !== 1) return;
    const selectedVoter = Array.from(selectedVoters)
      .map((id) => filteredVoters.find((v) => v._id === id))
      .filter(Boolean)[0];
    if (selectedVoter) {
      initiateCall([selectedVoter], false);
    }
  }, [selectionCount, selectedVoters, filteredVoters, initiateCall]);

  const handleBulkCall = useCallback(() => {
    if (selectionCount === 0) return;
    const selected = filteredVoters.filter((voter) =>
      selectedVoters.has(voter._id)
    );
    initiateCall(selected, true);
  }, [selectionCount, selectedVoters, filteredVoters, initiateCall]);

  // Utility Functions
  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  const getStatusBadge = (status) => {
    const badges = {
      not_called: { label: "Not Called", class: styles.statusNotCalled },
      completed: { label: "Completed", class: styles.statusCompleted },
      missed: { label: "Missed", class: styles.statusMissed },
    };

    const badge = badges[status] || badges.not_called;
    return (
      <span className={`${styles.statusBadge} ${badge.class}`}>
        {badge.label}
      </span>
    );
  };

  const canCall = !!selectedAgentId && selectionCount > 0;

  const renderStepper = (voter) => (
    <div key={voter._id} className={styles.stepper}>
      <h4>{voter.voterName} - {voter.voterId}</h4>
      <div className={styles.stepContainer}>
        <div className={styles.step} style={{ backgroundColor: '#10b981' }}> {/* Completed Query */}
          <span>Query Call Completed</span>
          <p>{voter.voterContact} | {voter.voterAddress}</p>
        </div>
        <div className={styles.stepArrow}>→</div>
        <div className={styles.step} style={{ backgroundColor: '#f59e0b' }}> {/* Promise Stage */}
          <span>Promise Follow-up</span>
          <p>Updated ID: {voter._id} | Type: {voter.type}</p>
        </div>
      </div>
    </div>
  );

  const renderVoterContent = () => {
    console.log("Rendering voter content - filteredVoters length:", filteredVoters.length); // Debug log
    console.log("Progressed voters length:", progressedVoters.length); // Debug log
    if (loading) {
      return (
        <div className={styles.loadingState}>
          <div className={styles.spinner}></div>
          <p>Loading...</p>
        </div>
      );
    }

    if (!selectedCampaign) {
      return (
        <div className={styles.emptyState}>
          <div className={styles.emptyStateIcon}>🗳️</div>
          <h2>Select a Campaign</h2>
          <p>Choose a campaign to view voters and initiate calls</p>
        </div>
      );
    }

    if (filteredVoters.length === 0) {
      return (
        <div className={styles.emptyState}>
          <div className={styles.emptyStateIcon}>🔍</div>
          <h3>No voters found</h3>
          <p>Try adjusting your search or filter criteria. Voters length: {voters.length}</p> {/* Debug */}
        </div>
      );
    }

    return (
      <>
        {/* Progress Steppers Section */}
        {/* {progressedVoters.length > 0 && (
          <div className={styles.progressSection}>
            <h3>Progress Steppers (Type Changes)</h3>
            {progressedVoters.map(renderStepper)}
          </div>
        )} */}

        {isMobile ? (
          // Card format for mobile
          <div className={styles.voterCards}>
            {paginatedVoters.map((voter) => (
              <div key={voter._id} className={styles.voterCard}>
                <div className={styles.cardHeader}>
                  <input
                    type="checkbox"
                    checked={selectedVoters.has(voter._id)}
                    onChange={() => toggleVoterSelection(voter._id)}
                    className={styles.checkbox}
                    disabled={isCalling || loading}
                  />
                  <div className={styles.voterInfo}>
                    <h4 className={styles.voterName}>
                      {voter.voterName || "N/A"}
                    </h4>
                    <p className={styles.voterId}>ID: {voter.voterId || "N/A"}</p>
                  </div>
                </div>
                <div className={styles.cardBody}>
                  <p>
                    <strong>Contact:</strong> {voter.voterContact || "N/A"}
                  </p>
                  <p className={styles.voterAddress}>
                    <strong>Address:</strong> {voter.voterAddress || "N/A"}
                  </p>
                  <div className={styles.statusContainer}>
                    <strong>Status:</strong> {getStatusBadge(voter.callStatus)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          // Table format for desktop
          <div className={styles.voterTable}>
            <table>
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={toggleSelectAll}
                      disabled={isCalling || loading}
                    />
                  </th>
                  <th>Voter ID</th>
                  <th>Name</th>
                  <th>Contact</th>
                  <th>Address</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {paginatedVoters.map((voter) => (
                  <tr key={voter._id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedVoters.has(voter._id)}
                        onChange={() => toggleVoterSelection(voter._id)}
                        disabled={isCalling || loading}
                      />
                    </td>
                    <td>{voter.voterId || "N/A"}</td>
                    <td>{voter.voterName || "N/A"}</td>
                    <td>{voter.voterContact || "N/A"}</td>
                    <td className={styles.addressCell}>
                      {voter.voterAddress || "N/A"}
                    </td>
                    <td>{getStatusBadge(voter.callStatus)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </>
    );
  };

  return (
    <div className={styles.callerbook}>
      {/* Notification */}
      {notification.show && (
        <div
          className={`${styles.notification} ${styles[notification.type]} ${styles.show
            }`}
        >
          <div className={styles.notificationContent}>
            <span className={styles.notificationIcon}>
              {notification.type === "success" && "✅"}
              {notification.type === "error" && "❌"}
              {notification.type === "warning" && "⚠️"}
              {notification.type === "info" && "ℹ️"}
            </span>
            <span className={styles.notificationMessage}>
              {notification.message}
            </span>
          </div>
        </div>
      )}

      {/* Header */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.headerLeft}>
            <h1 className={styles.title}>Election Caller Book</h1>
            <p className={styles.subtitle}>
              Initiate calls to voters efficiently
            </p>
          </div>
        </div>
      </header>

      {/* Controls */}
      <div className={styles.controls}>
        <div className={styles.dropdownGroup}>
          <div className={styles.formGroup}>
            <label className={styles.label}>Select Campaign</label>
            <select
              value={selectedCampaign?._id || ""}
              onChange={(e) => {
                const campaign = campaigns.find(
                  (c) => c._id === e.target.value
                );
                console.log("Selected campaign:", campaign); // Debug log
                setSelectedCampaign(campaign);
              }}
              className={styles.select}
              disabled={loading}
            >
              <option value="">Choose a campaign...</option>
              {campaigns.map((campaign) => (
                <option key={campaign._id} value={campaign._id}>
                  {campaign.leaderName} - {campaign.partyName}
                </option>
              ))}
            </select>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Select Agent (Prompt Type)</label>
            <select
              value={selectedPromptType || ""}
              onChange={handleAgentSelect}
              className={styles.select}
              disabled={loading}
            >
              <option value="">Choose a prompt type...</option>
              {promptAgents.map((item) => (
                <option key={item.promptType} value={item.promptType}>
                  {item.promptName} ({item.promptType}) {item.agentName ? `- Agent: ${item.agentName}` : '(No Agent Created)'}
                </option>
              ))}
            </select>
            {promptAgents.some(item => !item.agentId && item.promptType !== 'query' && item.promptType !== 'promise') && (
              <p className={styles.agentNote}>
                Note: Agents need to be created for Leader, Party, Influencer, and Custom prompt types to enable calls.
              </p>
            )}
          </div>
        </div>

        {/* Search and Filter */}
        {selectedCampaign && (
          <div className={styles.searchFilter}>
            <div className={styles.searchBox}>
              <input
                type="text"
                placeholder="Search voters..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
                className={styles.searchInput}
                disabled={loading}
              />
            </div>
            <select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setCurrentPage(1);
              }}
              className={styles.filterSelect}
              disabled={loading}
            >
              <option value="all">All Status</option>
              <option value="not_called">Not Called</option>
              <option value="completed">Completed</option>
              <option value="missed">Missed</option>
            </select>
          </div>
        )}

        {/* Call Buttons */}
        {selectedCampaign && (
          <div className={styles.callButtons}>
            {selectionCount === 1 && canCall && (
              <button
                className={styles.singleCallButton}
                onClick={handleSingleCall}
                disabled={isCalling || loading}
              >
                📞 Single Call
                {isCalling && <span className={styles.spinner}></span>}
              </button>
            )}
            {selectionCount > 1 && canCall && (
              <button
                className={styles.bulkCallButton}
                onClick={handleBulkCall}
                disabled={isCalling || loading}
              >
                📞 Bulk Call ({selectionCount})
                {isCalling && <span className={styles.spinner}></span>}
              </button>
            )}
            {selectionCount > 0 && !canCall && (
              <span className={styles.disabledMessage}>
                Select an agent and voters to enable calls
              </span>
            )}
          </div>
        )}
      </div>

      {/* Voter Content */}
      {renderVoterContent()}

      {/* Pagination - Only show on desktop or if not mobile */}
      {!isMobile && totalPages > 1 && filteredVoters.length > 0 && (
        <div className={styles.pagination}>
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1 || isCalling || loading}
            className={styles.paginationButton}
          >
            ← Previous
          </button>

          <div className={styles.pageNumbers}>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              const page = Math.max(1, currentPage - 2) + i;
              if (page > totalPages) return null;

              return (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  disabled={isCalling || loading}
                  className={`${styles.pageNumber} ${currentPage === page ? styles.active : ""
                    }`}
                >
                  {page}
                </button>
              );
            })}
          </div>

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages || isCalling || loading}
            className={styles.paginationButton}
          >
            Next →
          </button>
        </div>
      )}

      {/* Table Footer or Card Footer */}
      {filteredVoters.length > 0 && (
        <div className={styles.tableFooter}>
          Showing {(currentPage - 1) * votersPerPage + 1} to{" "}
          {Math.min(currentPage * votersPerPage, filteredVoters.length)} of{" "}
          {filteredVoters.length} voters
          {selectionCount > 0 && ` | Selected: ${selectionCount}`}
        </div>
      )}
    </div>
  );
};

export default ElectionCallerbook; 